import { system } from 'styled-system';

export const backgroundImageTheme = system({ backgroundImage: { property: 'backgroundImage', scale: 'colors' } });